import { Loader2, Square, Printer } from "lucide-react";

// A big, high-contrast, impossible-to-miss STOP control that floats over the
// page whenever a print job is running. The point is speed-to-stop in a panic
// moment — you should never have to hunt for it.
export function PrintStopBanner({ job, onStop }) {
  if (!job) return null;
  const { label, done, total } = job;
  const pct = total ? Math.min(100, Math.round((done / total) * 100)) : 0;
  return (
    <div
      data-testid="print-stop-banner"
      className="fixed inset-x-0 bottom-6 z-[200] flex justify-center px-4 pointer-events-none"
      role="alertdialog"
      aria-label="Printing in progress"
    >
      <div className="pointer-events-auto w-full max-w-2xl rounded-2xl bg-[#B01E28] text-white shadow-[0_20px_60px_-15px_rgba(176,30,40,0.8)] ring-4 ring-red-300/40 overflow-hidden animate-in slide-in-from-bottom-4 duration-200">
        <div className="flex items-center gap-4 px-5 py-4">
          <div className="flex items-center gap-3 min-w-0">
            <span className="relative flex h-3 w-3 shrink-0">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-white" />
            </span>
            <div className="min-w-0">
              <div className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/80">
                <Printer className="w-3.5 h-3.5" /> Printing…
              </div>
              <div className="text-sm font-semibold truncate" data-testid="print-stop-label">
                {label} · <span className="tabular-nums">{done}/{total}</span> sent
              </div>
            </div>
          </div>
          <button
            data-testid="print-stop-button"
            onClick={onStop}
            className="ml-auto shrink-0 flex items-center gap-2 rounded-xl bg-white text-[#B01E28] font-black text-base px-7 py-3.5 shadow-lg hover:bg-red-50 active:scale-95 transition-transform focus:outline-none focus:ring-4 focus:ring-white/50"
          >
            <Square className="w-5 h-5 fill-current" /> STOP
          </button>
        </div>
        <div className="h-1.5 bg-white/20">
          <div className="h-full bg-white transition-all duration-300" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
}
